import React, {useState} from 'react';
import {connect} from 'react-redux';
import {deepClone, sortBy, startCase} from 'lodash';


// local imports
import api from '../../../store/api'
import {toggleGlobalLoader, addErrorAlert, addLoadingAlert, removeLoadingAlert} from "../../../store/calls/alertLoadingDispatch";
import validators from "../../../utils/forms/validators";

import AdminWrapper from "../../theme/wrappers/AdminWrapper";

import ApplicationBuilder from "../../subcomponents/admin/ApplicationBuilder";
import FormModal from "../../theme/modals/FormModal";
import {hasFunderAdminPermissions} from "../../utils/auth";


export default class ApplicationRequirementSpecScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editingInstance: {
                id: props.match.params.id
            }
        }

        this.baseAPIPath = '/project-applications/' + this.state.editingInstance.id + '/';
    }

    componentDidMount() {
        toggleGlobalLoader(true);
        Promise.all([
            this.getData(),
        ])
            .then(() => toggleGlobalLoader(false))
            .catch(() => {
                addErrorAlert('Failed to load all initial data.', 10 * 1000);
                toggleGlobalLoader(false);
            })
    }

    toggleEditModal = () => {
        this.setState({editModalOpen: !this.state.editModalOpen})
    }


    getData = (xtraParams = {}) => {
        return api.get(this.baseAPIPath, xtraParams)
            .then(res => {
                this.setState({editingInstance: res.data})
            })
    }

    onUpdateTemplate = (data) => {
        toggleGlobalLoader(true)
        let update_data = {
            template: {
                ...this.state.editingInstance.template,
                elements: data.elements
            }
        }
        return api.patch(this.baseAPIPath, data)
            .then(res => this.setState({editingInstance: res.data}))
            .catch(() => addErrorAlert('There was a problem updating the object.'))
            .finally(() => toggleGlobalLoader(false))
    }


    render() {
        return (
            <AdminWrapper>
                <ApplicationBuilder
                    title={`Edit Template ${this.state.editingInstance?.name || ''}`}
                    onSave={this.onUpdateTemplate}
                    template={this.state.editingInstance?.template}
                    showMergeOptions={hasFunderAdminPermissions()}
                    mergeIntoObject={{type:"application", id: this.state.editingInstance.id}}
                    isGlobalTemplate={false}
                >
                    {/* CHILDREN ARE USED AS HEADER */}
                    <div className="p-4 pb-0">
                        <h3 className="title pb-2 m-0 is-size-3 has-text-primary">Edit Application</h3>
                        {!!this.state.editingInstance?.name &&
                            <div className="is-flex">
                                <h4 className="subtitle">{this.state.editingInstance.name}</h4>
                                <i
                                    onClick={() => { this.setState({displayEditNameModal: true})}}
                                    className="fas fa-edit ml-3 pt-1 has-text-primary cursor-is-pointer"
                                />
                            </div>
                        }
                    </div>

                </ApplicationBuilder>


            </AdminWrapper>
        )
    }

}

